(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-categories"] && !Shopify.designMode) return;
  try {
    
  class TopCategoriesSlider {
    constructor(section) {
      this.container = section.querySelector('.g-top-cat-main-container');
      if (!this.container) return;

      this.btnLeft = section.querySelector('.g-top-cat-nav-button--left');
      this.btnRight = section.querySelector('.g-top-cat-nav-button--right');

      this.init();
    }

    init() {
      if (!this.btnLeft || !this.btnRight) return;

      this.btnLeft.addEventListener('click', () => this.scroll(-1));
      this.btnRight.addEventListener('click', () => this.scroll(1));
      this.container.addEventListener('scroll', () => this.updateButtonState());

      // Initial check in case content doesn't fill the container
      // Use a slight delay to ensure all images are loaded and widths are correct
      setTimeout(() => {
          this.updateButtonState();
      }, 500);
    }

    scroll(direction) {
      const scrollAmount = this.container.clientWidth * 0.75; // Scroll by 75% of the visible width
      this.container.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
    }

    updateButtonState() {
      const scrollLeft = this.container.scrollLeft;
      const scrollWidth = this.container.scrollWidth;
      const clientWidth = this.container.clientWidth;

      // A 1px tolerance helps with browser sub-pixel rendering issues
      this.btnLeft.classList.toggle('g-top-cat-nav-button--hidden', scrollLeft <= 1);
      this.btnRight.classList.toggle('g-top-cat-nav-button--hidden', scrollLeft + clientWidth >= scrollWidth - 1);
    }
  }

  // Standard Shopify Section event listener
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.id.startsWith('g-top-cat--')) {
      new TopCategoriesSlider(section);
    }
  });

  // Initial load for sections already on the page
  document.querySelectorAll('.g-top-cat-section-wrapper').forEach(section => {
    new TopCategoriesSlider(section);
  });

  } catch(e) { console.error(e); }
})();
})();
